import { TromanError } from '../../common/TromanError';

/**
 * @typedef { import('../objects/Payment').Payment } Payment
 * @typedef { import('./PaymentGroupModel').PaymentGroupModel } PaymentGroupModel
 * @typedef { import('./calculation/CalculatedPayment').CalculatedPayment } CalculatedPayment
*/

export class PaymentModel {
    /**
     * @param {PaymentGroupModel} group
     * @param {Payment} payment
     */
    constructor(group, payment) {
        if (group == null) throw new TromanError('missing_argument');
        if (payment == null) throw new TromanError('missing_argument');

        this.group = group;
        this.payment = payment;

        this.selectedEmployer = null;
        this.needsSaving = false;
        this.isAutoTravel = false;
    }

    /**
     * @param {PaymentGroupModel} group
     * @param {Payment} payment
     */
    static fromOriginal(group, payment) {
        return new PaymentModel(group, payment);
    }

    /**
     * @param {PaymentGroupModel} group
     * @param {Payment} payment
     */
    static fromCreated(group, payment) {
        let model = new PaymentModel(group, payment);
        model.needsSaving = true;
        return model;
    }

    /**
     * @param {PaymentGroupModel} group
     * @param {CalculatedPayment} calculatedPayment
     */
    static fromCalculated(group, calculatedPayment) {
        let model = new PaymentModel(group, calculatedPayment.payment);
        model.needsSaving = true;
        model.selectedEmployer = calculatedPayment.chosenEmployer;
        return model;
    }
}
